export enum OWWindowAnchorTypes {
  topLeft,
  topRight,
  middleRight,
  bottomRight,
  bottomLeft
}
